<template lang="pug">
  router-view
</template>

<script>
import '@/assets/css/fonts.css'
import '@/assets/css/main.css'

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Omnes Regular', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f1f1f;
}

body h1,
body h2 {
  font-family: 'Omnes Medium';
  color: #1f1f1f;
  font-weight: bold;
}

.swal2-popup {
  width: 85% !important;
  height: 440px;
}

.swal2-popup .swal2-image {
  margin: 0 auto !important;
}

.swal2-popup .swal2-styled.swal2-confirm {
  font-family: 'Omnes Medium';
}

.swal2-popup #swal2-content,
.swal2-popup #swal2-content p,
.swal2-popup #swal2-content a {
  color: #535d66 !important;
  font-family: 'Omnes Regular';
}

.swal2-popup #swal2-content a {
  text-decoration: underline;
  font-family: 'Omnes Medium';
}

.swal2-popup .swal2-title {
  font-family: 'Omnes Semibold' !important;
  color: #0855c4 !important;
  font-size: 18px !important;
  line-height: 1.5 !important;
  margin-top: 1.5rem !important;
  margin-bottom: 1rem !important;
}

.swal2-popup .swal2-confirm {
  border-radius: 4px !important;
  font-size: 18px !important;
  height: 50px !important;
  margin: 0 !important;
}

.swal2-popup .swal2-styled:focus {
  box-shadow: none !important;
}

.swal2-popup .swal2-close,
.swal2-popup .swal2-close:hover {
  color: #0855c4 !important;
}

body h3,
body p,
body input,
body select option,
body span,
body label {
  font-family: 'Omnes Regular';
  color: #242424;
}

body a {
  font-family: 'Omnes Regular';
  color: #1f1f1f;
}

/* body select.custom-select {
  background: #fff url(assets/arrow_down.png) no-repeat right 0.75rem center;
} */
@media only screen and (min-width: 1024px) {
  .swal2-popup {
    width: 23% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue